import type { Signal } from '@preact/signals-react';
import { cloneDeep } from 'lodash';
import type { ContinuousScrollerFilter } from '../../continuous-scroller/continuous-scroller-types';

export class DropDownFeatures {
  private _filters: Signal<Array<ContinuousScrollerFilter>>;

  constructor(_filters: Signal<Array<ContinuousScrollerFilter>>) {
    this._filters = _filters;
  }

  public get filters() {
    return this._filters.value;
  }

  public containsFilter(filter: ContinuousScrollerFilter) {
    return this.getFilterIndex(filter.field) > -1;
  }

  public addFilter(filter: ContinuousScrollerFilter) {
    const currentFilters = cloneDeep(this._filters.value);

    if (!this.containsFilter(filter)) {
      this._filters.value = [...currentFilters, filter];
    } else {
      this.updateFilter(filter);
    }
  }

  public updateFilter(filter: ContinuousScrollerFilter) {
    const filterIndex = this.getFilterIndex(filter.field);

    if (filterIndex > -1) {
      const currentFilters = cloneDeep(this._filters.value);
      currentFilters.splice(filterIndex, 1, filter);
      this._filters.value = currentFilters;
    }
  }

  public removeFilter(filter: ContinuousScrollerFilter) {
    this.removeFilterByField(filter.field);
  }

  public removeFilterByField(field: string) {
    const filterIndex = this.getFilterIndex(field);

    if (filterIndex > -1) {
      const currentFilters = cloneDeep(this._filters.value);
      currentFilters.splice(filterIndex, 1);
      this._filters.value = currentFilters;
    }
  }

  private getFilterIndex(field: string) {
    return this._filters.value.findIndex((item) => item.field === field);
  }
}
